import { Line } from "fabric";
import { guideColor } from "../constants/common";
// Helper function to create guide lines with common properties
export const createGuideLine = (
  points: [number, number, number, number],
  strokeWidth: number,
  borderScaleFactor?: number
): Line => {
  return new Line(points, {
    stroke: guideColor,
    strokeWidth: strokeWidth,
    borderScaleFactor: borderScaleFactor || 1,
    selectable: false,
    evented: false,
    strokeUniform: true,
    // Set a high z-index to ensure guides appear above all other objects
    zIndex: 9999,
  });
};

export const getFileName = (fileName: string): string => {
  let lastIndex = fileName.lastIndexOf(".");
  if (lastIndex > -1) {
    fileName = fileName.substring(0, lastIndex);
  }
  return fileName;
};
